var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.147,
    height: 16.147,
    viewBox: "0 0 16.147 16.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_7079",
    "data-name": "Group 7079",
    transform: "translate(0 0)",
    style: {
      isolation: "isolate"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 2.097,
    cy: 2.097,
    r: 2.097,
    transform: "translate(10.226 5.977) rotate(90)",
    fill: "#4f5b6d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-down",
    d: "M.423,0H5.866a.422.422,0,0,1,.3.721L3.444,3.444a.424.424,0,0,1-.6,0L.125.721A.422.422,0,0,1,.423,0Z",
    transform: "translate(3.568 4.928) rotate(90)",
    fill: "#4f5b6d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "caret-down-2",
    "data-name": "caret-down",
    d: "M.423,0H5.866a.422.422,0,0,1,.3.721L3.444,3.444a.424.424,0,0,1-.6,0L.125.721A.422.422,0,0,1,.423,0Z",
    transform: "translate(12.579 11.218) rotate(-90)",
    fill: "#4f5b6d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "caret-down-3",
    "data-name": "caret-down",
    d: "M.423,0H5.866a.422.422,0,0,1,.3.721L3.444,3.444a.424.424,0,0,1-.6,0L.125.721A.422.422,0,0,1,.423,0Z",
    transform: "translate(11.218 3.567) rotate(180)",
    fill: "#4f5b6d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "caret-down-4",
    "data-name": "caret-down",
    d: "M.423,0H5.866a.422.422,0,0,1,.3.721L3.444,3.444a.424.424,0,0,1-.6,0L.125.721A.422.422,0,0,1,.423,0Z",
    transform: "translate(4.929 12.579)",
    fill: "#4f5b6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIconGray);
export default __webpack_public_path__ + "static/media/move-icon-gray.70d65480abf616ad984a9fc6eaaed6f1.svg";
export { ForwardRef as ReactComponent };